import { AfterViewInit, ChangeDetectionStrategy, Component, input, output, Type, ViewChild } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { ColumnFilterComponentBase } from '../column-filter-component-base.interface';
import { FilterMetadata } from '@irian-ro/abstract-resource';
import { FilterMatchMode } from 'primeng/api';

@Component({
  selector: 'lib-column-filters-component-outlet',
  standalone: true,
  imports: [NgComponentOutlet],
  templateUrl: './column-filters-component-outlet.component.html',
  styleUrl: './column-filters-component-outlet.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColumnFiltersComponentOutletComponent implements AfterViewInit {
  component = input.required<Type<any>>();
  inputs = input<{ value: unknown; filterMatchMode?: FilterMatchMode; [key: string]: unknown }>();
  filtersChange = output<FilterMetadata>();

  @ViewChild(NgComponentOutlet, { read: NgComponentOutlet })
  private outlet!: NgComponentOutlet;

  ngAfterViewInit() {
    const instance: ColumnFilterComponentBase = this.outlet['_componentRef'].instance;

    instance.filtersChange.subscribe((filterMetadata) => {
      this.filtersChange.emit(filterMetadata);
    });
  }
}
